import { Dictionaries } from './dictionary';
const en: Dictionaries = {
  'reveal.text': 'read more',

  'summary.transactionDate': 'Transaction date',
  'summary.transactionAmount': 'Amount',
  'summary.transactionReceiveAmount': 'Paid amount',
  'summary.email': 'E-mail address',
  'summary.transactionId': 'Transaction number',
  'summary.paymentMethod': 'Payment method',
  'summary.include': 'Includes',
  'summary.identifier': 'Id searched',

  'form.header': 'Check your payment status',

  'formData.amount': 'Amount',
  'formData.currency': 'Currency',
  'formData.transactionDate': 'Transaction date',
  'formData.transactionId': 'Transaction Id,  Order Id or Reference',
  'formData.paymentMethod': 'Payment method',
  'formData.email': 'E-mail ',
  'formData.separator': '---------------------- OR ----------------------',

  'formData.button': 'Next',
  'formData.buttonSearchByEmail': 'Give your e-mail address',
  'formData.buttonSearchByTransId': 'Give transaction identifier',
  'formData.buttonSubmitAll': 'Check payment status',
  'formData.buttonSeparator': 'OR',
  'formData.tryAgainButton': 'Try again',
  'formData.sendVoucherButton': 'Send the voucher',
  'formData.errorSendingVoucher': 'Error sending the voucher',
  'formData.completeSendVoucher': 'Voucher sent to the registered email',

  'formData.validation.required': 'Field is required',
  'formData.validation.date.incorrect': 'The date must be from the last 3 months',
  'formData.validation.gt.zero': 'Amount must be grater than zero',
  'formData.validation.incorrectEmail': 'Incorrect email format',

  'transactionStatus.header': 'Transaction status',

  'status.AUTHORIZED': 'Authorized',
  'status.ABANDONED': 'Abandoned',
  'status.ANTIFRAUD_REJECTED': 'Antifraud rejected',
  'status.BANK_FRAUD_REJECTED': 'Bank rejection',
  'status.BANK_REJECTED': 'Bank rejection',
  'status.CANCELLED': 'Cancelled',
  'status.ERROR': 'Error',
  'status.EXPIRED': 'Expired',
  'status.PLATFORM_REJECTED': 'Platform rejected',
  'status.PAID': 'Paid',
  'status.CHARGEBACK': 'Chargeback',
  'status.PENDING': 'Pending',
  'status.REFUND': 'Refund',
  'status.IN_DISPUTE': 'In dispute',
  'status.PARTIAL_REFUND': 'Partial refund',
  'status.THREEDS_REJECTED': '3ds rejected',
  'status.RETURNING': 'Returning refund',
  'status.NOT_FOUND': 'Other',

  'transaction-info.authorized.body':
      '<p>Your transaction has been authorized. To request collection or release of funds please contact the merchant.</p>',
  'transaction-info.abandoned.body':
      '<p>Please try to make the payment again.</p>',
  'transaction-info.antifraud-rejected.body':
      '<p>Please contact our customer service area, having the following information at hand: transaction date, order number and transaction reference. Remember that in your country\'s PayU page you will find the support section, through which you can contact our Customer Service team.</p>',
  'transaction-info.bank-fraud-rejected.body':
      '<p>Contact your bank and verify the reason why you have not been able to make the purchase. Once they tell you, you can try again to make the purchase.</p>',
  'transaction-info.bank-rejected.body':
      '<p>Contact your bank and verify the reason why you have not been able to make the purchase. Once they tell you, you can try again to make the purchase.</p>',
  'transaction-info.cancelled.body':
      '<p>Your transaction is cancelled. Please try again.</p>',
  'transaction-info.error.body':
      '<p>Your transaction has not been approved. Please try again.</p>',
  'transaction-info.expired-card.body':
      '<p>Your card is expired. Try another payment method.</p>',
  'transaction-info.expired-transaction.body':
      '<p>The order exceeded the time limit that you had to make the payment, try again or if you made the payment and still continues in this state, it is necessary that you send us the support of the payment.</p>',
  'transaction-info.platform-rejected.body':
      '<p>Your transaction has been declined, please try to make the payment again.</p>',
  'transaction-info.paid.body':
      '<p>The transaction is paid to the merchant. You can contact the merchant directly to schedule the delivery of the product or service.</p>',
  'transaction-info.chargeback.body':
      '<p>The order presented a claim process by the cardholder to his bank, so you must validate directly with the financial entity the return of the money.</p>',
  'transaction-info.pending.body':
      '<p>If you paid with a card, we’re performing additional validations to ensure everything is in order. We’ll get back to you within a maximum of 4 business hours. If you used another payment method, the process hasn’t been completed yet, please check it. If you have any questions, visit our website and go to the Support section.</p>',
  'transaction-info.refund.body':
      '<p>The money was refunded by the merchant. Please note that the refund may take between 15 and 25 business days from the time the merchant requested the refund. If you want to know exactly the current status of the refund you should validate it directly with your bank.</p>',
  'transaction-info.in-dispute.body':
      '<p>The order presents a claim process by the cardholder to his bank. If you want to know exactly the current status of the process, you must validate it directly with the bank.</p>',
  'transaction-info.partial-refund.body':
      '<p>The order presents a partial refund, of the total amount of the purchase, by the store. Please note that the refund may take between 15 and 25 business days from the time the store requested the refund. If you want to know exactly the current status of the refund, you must validate it directly with your bank.</p>',
  'transaction-info.threeds-rejected.body':
      '<p>Transaction declined. Try another payment method or check with your bank.</p>',
  'transaction-info.returning.body':
      '<p>The order is in the process of being reimbursed by the financial network. It may take 15 to 25 business days for the money to be credited by your bank to your bank account.</p>',
  'transaction-info.not-found.body':
      '<p>If you have any questions please contact us through our support channels.</p>',


  'status.commercialName': 'Merchant: ',
  'status.orderId': 'Order Id: ',
  'status.reference': 'Reference: ',
  'status.paymentMethod': 'Payment method: ',
  'status.status': 'Status: ',

  'status.notFound.title': 'Payment not found',
  'status.notFound.message':
    'No transactions were found for the specified search data. Please try again with different parameters or contact us.',

  'errorView.title': 'An error has occurred',
  'errorView.message':
    'We are sorry but an unexpected error occurred during the payment searching. Please try again later.',
  'captcha.error':
    'We are sorry but an unexpected error occurred during the captcha. Please try again.',

  'formIntroFirstStep.titleLine':
    'To find out the payment status please provide the Id of the transaction, or the relevant data related to it – you will find transactions for the last 3 months',
  'formIntroFirstStep.space': ' ',

  'selectCurrency.placeholder': 'Choose',
  'selectCurrency.noOption': 'Invalid currency',
  'selectPaymentMethod.noOption': 'Invalid payment method',
  'selectDate.placeholder': 'Choose',

  'WALLET': 'Wallet',
  'CASH': 'Cash',
  'REFERENCED': 'Bank referenced',
  'PSE': 'PSE',
  'CARD': 'Card',
  'BANK_TRANSFER': 'Bank transfer',

  'privacy.policy.text': 'We use your personal information to check the status of your payment and provide information about your transaction. You can read our Privacy Policy',
  'privacy.policy.link-text': ' here.',
  'privacy.policy.link': 'https://corporate.payu.com/privacy/global-privacy-statement/',

  'footer.captcha.textStart': 'This site is protected by reCAPTCHA and the Google ',
  'footer.captcha.privacyLink': 'Privacy Policy',
  'footer.captcha.and': ' and ',
  'footer.captcha.serviceTermsLink': 'Terms of Service',
  'footer.captcha.textEnd': ' apply.',

  'payu.contact.url': 'https://colombia.support.payu.com/s/?language=es',
};
export default en;
